import { OrganisationProfileProvider } from './context/OrganisationProfileProvider'
import { OrganisationFilters } from './components/OrganisationFilters/OrganisationFilters'
import { OrganisationDirectory } from './components/OrganisationDirectory/OrganisationDirectory'
import { OrganisationTable } from './components/OrganisationTable/OrganisationTable'
import { OrganisationProfileCard } from './components/OrganisationProfileCard/OrganisationProfileCard'
import { OrganisationProfilePage } from './components/OrganisationProfilePage/OrganisationProfilePage'
import { OrganisationDonationSummary } from './components/OrganisationDonationSummary/OrganisationDonationSummary'
import { OrganisationProfileHeader } from './components/OrganisationProfileHeader/OrganisationProfileHeader'
import { OrganisationDetails } from './components/OrganisationDetails/OrganisationDetails'
import type { OrganisationProfile as OrganisationProfileData } from './types/organisationProfile.types'

// Host wraps with <OrganisationProfile.Provider service={...} countries={...}>.
export const OrganisationProfile = {
  Provider: OrganisationProfileProvider,
  Directory: OrganisationDirectory,
  Filters: OrganisationFilters,
  Table: OrganisationTable,
  ProfileCard: OrganisationProfileCard,
  ProfileHeader: OrganisationProfileHeader,
  ProfileDetails: OrganisationDetails,
  ProfilePage: OrganisationProfilePage,
  DonationSummary: OrganisationDonationSummary,
}

// The namespace above shadows the profile type from `export *`; re-export it under the same name.
export type OrganisationProfile = OrganisationProfileData

export * from './types/organisationProfile.types'
export { useOrganisationProfile } from './hooks/useOrganisationProfile'
export {
  OrganisationProfileContext,
  useOrganisationProfileContext,
} from './context/OrganisationProfileContext'
export type {
  OrganisationProfileService,
  OrganisationProfileContextValue,
} from './context/OrganisationProfileContext'
export type { OrganisationProfileProviderProps } from './context/OrganisationProfileProvider'
export type { OrganisationDirectoryProps } from './components/OrganisationDirectory/OrganisationDirectory'
export type {
  OrganisationFiltersProps,
  OrganisationFiltersValue,
} from './components/OrganisationFilters/OrganisationFilters'
export type { OrganisationTableProps } from './components/OrganisationTable/OrganisationTable'
export type { OrganisationProfileCardProps } from './components/OrganisationProfileCard/OrganisationProfileCard'
export type { OrganisationProfilePageProps } from './components/OrganisationProfilePage/OrganisationProfilePage'
export type { OrganisationDonationSummaryProps } from './components/OrganisationDonationSummary/OrganisationDonationSummary'
export type { OrganisationProfileHeaderProps } from './components/OrganisationProfileHeader/OrganisationProfileHeader'
export type { OrganisationDetailsProps } from './components/OrganisationDetails/OrganisationDetails'
